import './SearchInput.css'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { debounce } from 'throttle-debounce'

const MagnifIcon = () => <div className="fm fm-magnif" />

function SearchInput({ debounceDuration, icon, iconLeft, onChange, onDebounceEnd, placeholder, value }: any) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(debounce(debounceDuration, onDebounceEnd), [])
  const enhancedOnChange = (event: any) => {
    onChange(event.target.value)

    if (onDebounceEnd) {
      debouncedSearch(event.target.value)
    }
  }

  return (
    <div className="search-input">
      {iconLeft && <div className="icon-left">{iconLeft}</div>}
      <input
        className={classNames('search-input-control', iconLeft && 'has-icon-left')}
        onChange={enhancedOnChange}
        placeholder={placeholder}
        type="text"
        value={value}
      />
      {icon}
    </div>
  )
}

SearchInput.defaultProps = {
  debounceDuration: 300,
  icon: <MagnifIcon />,
  iconLeft: null,
  placeholder: '',
}

SearchInput.propTypes = {
  debounceDuration: PropTypes.number,
  icon: PropTypes.node,
  iconLeft: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  onDebounceEnd: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
}

export default SearchInput as any
